import React from 'react'
import { Label } from "semantic-ui-react";
import { Header } from "semantic-ui-react";
import { Table } from "semantic-ui-react";
import { Image, List } from 'semantic-ui-react'

class EmploymentsListItem extends React.Component {

  render() {
    const employment = this.props.employment

    return (
      <Table.Row key={employment.id}>
        <Table.Cell collapsing>
          <Image src={employment.photoUrl} avatar/>
        </Table.Cell>
        <Table.Cell>
          <Header as='h4' style={{marginBottom: 0}}>{`${employment.user?.firstName} ${employment.user?.lastName}`}</Header>
          {this.getEmploymentType(employment.roles)}
        </Table.Cell>
        <Table.Cell>
          {employment.teamNames.map((name) => <Label key={name} content={name}/>)}
        </Table.Cell>
      </Table.Row>
    )
  }

  getEmploymentType(roles) {
    if(roles.includes("practitioner") && roles.includes('administrator')) {
      return I18n.t(`components.employments_list_item.employment_type.practice_manager`)
    } else if(roles.includes("administrator")) {
      return I18n.t(`components.employments_list_item.employment_type.administrative`)
    } else if(roles.includes('practitioner')) {
      return I18n.t(`components.employments_list_item.employment_type.practitioner`)
    }
  }
}

export default EmploymentsListItem;
